var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessImgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9223 0.0776676C10.8187 -0.0258892 10.651 -0.0258892 10.5474 0.0776676L9.66468 0.960386C9.50612 0.866191 9.32212 0.811048 9.12568 0.811048L6.45676 0.809586C6.19713 0.817923 5.93619 0.920895 5.73976 1.11806L0.310195 6.54777C-0.103008 6.96068 -0.103593 7.64448 0.30961 8.05812L2.94197 10.69C3.35576 11.1038 4.03956 11.103 4.45203 10.6896L9.88159 5.26019C10.0792 5.06287 10.1809 4.80398 10.1895 4.54377V1.87441C10.1893 1.67768 10.1339 1.49367 10.0396 1.33512L10.9223 0.452403C11.0257 0.348992 11.0257 0.181078 10.9223 0.0776676ZM9.21505 2.75873C9.21491 3.29714 8.77918 3.73331 8.24048 3.73331C7.70251 3.73331 7.2659 3.29714 7.2659 2.75873C7.2659 2.22047 7.70251 1.78431 8.24048 1.78416C8.41351 1.78416 8.57557 1.8298 8.71643 1.90863L8.29986 2.3252C8.16413 2.30472 8.02093 2.34553 7.91635 2.45011C7.74142 2.62505 7.74142 2.90866 7.91635 3.08359C8.09129 3.25853 8.3749 3.25853 8.54983 3.08359C8.65441 2.97901 8.69493 2.83596 8.67474 2.70023L9.09117 2.28381C9.16986 2.42437 9.21505 2.58614 9.21505 2.75873Z",
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessImgTag);
export default __webpack_public_path__ + "static/media/process-img-tag.70d83b9bf103ba02549ae7657a05cbb7.svg";
export { ForwardRef as ReactComponent };